<template>
  <div>
    <h1><v-icon color="primary" class="mr-2">mdi-cog</v-icon>Configuración del sistema</h1>

    <v-tabs v-model="tab" color="primary" class="mt-3 rounded-xl elevation-2">
      <v-tab><v-icon left>mdi-store-settings</v-icon>General</v-tab>
      <v-tab><v-icon left>mdi-email-cog</v-icon>Email &amp; Seguridad</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="mt-3">
      <!-- Tab 1: Configuración General del Gimnasio -->
      <v-tab-item>
        <form-configuracion
          v-if="datosAjustes"
          :ajustes="datosAjustes"
          @registrar="onRegistrar"
        />
      </v-tab-item>

      <!-- Tab 2: Email + 2FA -->
      <v-tab-item>
        <config-email-seguridad
          v-if="datosAjustes"
          :ajustes="datosAjustes"
          @guardar-smtp="onRegistrar"
        />
        <!-- Botón guardar configuración -->
        <div class="mt-4 text-right">
          <v-btn color="primary" rounded elevation="3" @click="guardar" :loading="cargando">
            <v-icon left>mdi-content-save</v-icon> Guardar configuración email
          </v-btn>
        </div>
      </v-tab-item>
    </v-tabs-items>

    <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top>
      {{ mensaje.texto }}
    </v-snackbar>
    <v-overlay :value="cargando && !datosAjustes">
      <v-progress-circular size="64" indeterminate />
    </v-overlay>
  </div>
</template>

<script>
import FormConfiguracion from './FormConfiguracion.vue'
import ConfigEmailSeguridad from './ConfigEmailSeguridad.vue'
import HttpService from '../../Servicios/HttpService'

export default {
  name: 'ConfiguracionComponent',
  components: { FormConfiguracion, ConfigEmailSeguridad },

  data: function() {
    return {
      tab: 0,
      datosAjustes: null,
      cargando: false,
      mostrarMensaje: false,
      mensaje: { texto: '', color: '' },
    }
  },

  mounted: function() { this.obtenerAjustes() },

  methods: {
    guardar: function() {
      if (this.datosAjustes) this.onRegistrar(this.datosAjustes)
    },

    onRegistrar: function(ajustes) {
      var self = this
      this.cargando = true
      var imagenCambia = ajustes.logo && ajustes.logo.includes('data:image')
      if (!imagenCambia && ajustes.logo && ajustes.logo.includes('api/')) {
        ajustes.logo = ajustes.logo.split('api/')[1]
      }
      ajustes.logoCambia = imagenCambia
      HttpService.registrar({ metodo: 'registrar', ajustes: ajustes }, 'ajustes.php')
      .then(function(resultado) {
        if (resultado) {
          self.mostrarMensaje = true
          self.mensaje = { texto: 'Configuración guardada', color: 'success' }
          self.obtenerAjustes()
        }
        self.cargando = false
      })
    },

    obtenerAjustes: function() {
      var self = this
      this.cargando = true
      HttpService.obtenerConDatos({ metodo: 'obtener' }, 'ajustes.php')
      .then(function(resultado) {
        self.datosAjustes = resultado
        self.cargando = false
      })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Configuracion/ConfiguracionComponent.vue